<!-- Skeleton Loader Principal -->
<ng-container [ngSwitch]="type">

    <!-- 1️ - CARD CAMPANHA DASH -->
    <ng-container *ngSwitchCase="'card-campanha-dash'">
        <div class="card-campanha w-full" *ngFor="let item of [].constructor(count)">
            <div class="code mr-3">
                <p-skeleton width="2rem" height="1rem"></p-skeleton>
                <p-skeleton width="4rem" height="1.2rem"></p-skeleton>
            </div>
            <article class="tittle mr-5" *ngFor="let col of [1,2,3,4]">
                <p-skeleton width="6rem" height="1rem"></p-skeleton>
                <p-skeleton width="12rem" height="1.2rem"></p-skeleton>
            </article>
            <div class="item-icon mr-5">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
            <div class="flex justify-center text-center items-center">
                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <!-- 2️ - CARD DOACAO -->
    <ng-container *ngSwitchCase="'card-doacao'">
        <div class="card-doacao" *ngFor="let item of [].constructor(count)">
            <div class="code">
                <p-skeleton width="60%" height="1rem"></p-skeleton>
                <p-skeleton width="80%" height="1.2rem"></p-skeleton>
            </div>
            <article *ngFor="let col of [1,2,3,4]">
                <p-skeleton width="50%" height="1rem"></p-skeleton>
                <p-skeleton width="80%" height="1.2rem"></p-skeleton>
            </article>
            <div class="item-icon">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
            <div class="flex justify-center text-center items-center">
                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <!-- 3️-  CARD PAGAMENTO -->
    <ng-container *ngSwitchCase="'card-pagamento'">
        <div class="card-doacao w-100" *ngFor="let item of [].constructor(count)">
            <div class="code mr-2">
                <p-skeleton width="2rem" height="1rem"></p-skeleton>
                <p-skeleton width="4rem" height="1.2rem"></p-skeleton>
            </div>
            <article *ngFor="let col of [1,2,3,4,5]" class="mr-4">
                <p-skeleton width="5rem" height="1rem"></p-skeleton>
                <p-skeleton width="10rem" height="1.2rem"></p-skeleton>
            </article>
            <div class="item-icon mr-3">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
            <div class="flex justify-center text-center items-center">
                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <!-- 4️ - CARD USER -->
    <ng-container *ngSwitchCase="'card-user'">
        <div class="card-user w-full" *ngFor="let item of [].constructor(count)">
            <div class="code mr-3">
                <p-skeleton width="2rem" height="1rem"></p-skeleton>
                <p-skeleton width="4rem" height="1.2rem"></p-skeleton>
            </div>
            <article *ngFor="let col of [1,2,3,4]" class="tittle mr-5">
                <p-skeleton width="6rem" height="1rem"></p-skeleton>
                <p-skeleton width="12rem" height="1.2rem"></p-skeleton>
            </article>
            <div class="item-icon mr-5">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
            <div class="flex justify-center text-center items-center">
                <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <!-- 5️ - LISTA COMENTÁRIOS -->
    <ng-container *ngSwitchCase="'lista-comentarios'">
        <div class="comment_item" *ngFor="let item of [].constructor(count)">
            <div class="initial">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
            <div class="comment_body w-full">
                <p-skeleton width="30%" height="1rem"></p-skeleton>
                <p-skeleton width="90%" height="2rem" styleClass="mt-2"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <!-- 6️ - CAMPANHA GRAND -->
    <ng-container *ngSwitchCase="'campanha-grand'">
        <div class="campanha_item" *ngFor="let item of [].constructor(count)">
            <p-skeleton width="55%" height="18rem" styleClass="border-round-lg"></p-skeleton>
            <div class="campanhaItem_content">
                <p-skeleton width="60%" height="1.4rem"></p-skeleton>
                <p-skeleton width="40%" height="1rem" styleClass="mt-2"></p-skeleton>
                <p-skeleton width="90%" height="4rem" styleClass="mt-3"></p-skeleton>
                <p-skeleton width="90%" height="1rem" styleClass="mt-3"></p-skeleton>
                <p-skeleton width="100%" height="1rem" styleClass="mt-2"></p-skeleton>
                <p-skeleton width="80%" height="2.5rem" styleClass="mt-3 border-round-lg"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <!-- 6️ - CARD  CAMPANHA -->
    <ng-container *ngSwitchCase="'card-campanha'">
        <div *ngFor="let item of [].constructor(count)" [style.width]="'300px'">
            <p-card class="border-round-xl col-4" [style.width]="'350px'">
                <p-skeleton width="100%" height="240px" styleClass="border-round-lg mb-4"></p-skeleton>

                <p-skeleton width="60%" height="1.4rem" styleClass="mb-3"></p-skeleton>

                <div class="flex align-items-center mb-3">
                    <p-skeleton shape="circle" size="1.2rem" styleClass="mr-2"></p-skeleton>
                    <p-skeleton width="40%" height="1rem"></p-skeleton>
                </div>

                <p-skeleton width="90%" height="3rem" styleClass="mb-3"></p-skeleton>

                <div class="flex justify-content-between align-items-center my-3">
                    <div class="flex">
                        <p-skeleton *ngFor="let i of [1,2,3]" shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
                    </div>
                    <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
                </div>

                <div class="my-2">
                    <p-skeleton width="40%" height="1rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="100%" height="14px" styleClass="border-round-lg"></p-skeleton>
                </div>

                <div class="flex justify-content-between mt-3 gap-2">
                    <p-skeleton width="30%" height="1rem"></p-skeleton>
                    <p-skeleton width="30%" height="1rem"></p-skeleton>
                    <p-skeleton width="30%" height="1rem"></p-skeleton>
                </div>
            </p-card>
        </div>
    </ng-container>


    <!-- 7️ - DETALHE CAMPANHA -->
    <ng-container *ngSwitchCase="'detalhe-campanha'">
        <div class="campanha_item">
            <p-skeleton width="50%" height="25rem" styleClass="border-round-lg"></p-skeleton>
            <div class="detalhe_content">
                <p-skeleton width="60%" height="1.4rem"></p-skeleton>
                <p-skeleton width="40%" height="1rem" styleClass="mt-2"></p-skeleton>
                <p-skeleton width="90%" height="5rem" styleClass="mt-3"></p-skeleton>
                <p-skeleton width="100%" height="1rem" styleClass="mt-2"></p-skeleton>
                <p-skeleton width="80%" height="2rem" styleClass="mt-3"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <!--  DEFAULT -->
    <ng-container *ngSwitchDefault>
        <p-skeleton width="100%" height="2rem"></p-skeleton>
    </ng-container>

</ng-container>